// User-level display preferences (PRD 50).
//
// A singular resource on the caller: no id in the path, and no way to read or
// write anybody else's. What it carries says what this client should DRAW —
// never what the user may reach.

import { apiFetch } from '../utils/apiUtils';

const BASE = '/api/v1/app_preferences';

export interface AppPreferences {
  /**
   * True when this user has asked not to see the Personal side of the app.
   * Presentation only: personal data keeps syncing and every personal route
   * still resolves.
   */
  personal_hidden: boolean;
}

const parse = async (response: Response): Promise<AppPreferences> => {
  if (!response.ok) throw new Error(`app_preferences ${response.status}`);
  const body = await response.json();
  return { personal_hidden: Boolean(body?.app_preferences?.personal_hidden) };
};

class AppPreferencesService {
  async get(): Promise<AppPreferences> {
    return parse(await apiFetch(BASE));
  }

  /**
   * Only the keys passed are changed — the server leaves the rest alone — so a
   * partial update cannot reset a preference this client does not know about.
   */
  async update(changes: Partial<AppPreferences>): Promise<AppPreferences> {
    return parse(await apiFetch(BASE, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ app_preferences: changes }),
    }));
  }
}

export const appPreferencesService = new AppPreferencesService();
export default appPreferencesService;
